<style scoped>
  .smiley {
    font-size: 2em;
    font-family: "Noto Color Emoji", "Apple Color Emoji", "Segoe UI Emoji", Times, Symbola, Aegyptus, Code2000, Code2001, Code2002, Musica, serif, LastResort!important;
    position: absolute;
    bottom: 0;
    opacity: 0;
  }


</style>

<template>

  <div
    class="smiley"
    v-html="code"
    :style="{ right }"
   >
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
      required: true
    },
    code: {
      type: String,
      required: true
    },
    right: {
      type: String,
      required: true
    }
  },
  data() {
    return {

    }
  },
  computed: {
    containerHeight() {
      return this.$parent.$el.offsetHeight
    }
  },
  methods: {

  },
  watch: {
  },
  created() {
  }
}
</script>
